module.exports = __webpack_public_path__ + "img/alert-solid-red.3f6a61df.svg";